import { AnswerVehicle, VehicleConfig } from '../interfaces/interface.vehicle';
import EventBus from '../services/service.eventBus';
import { state as dynamicEntryState } from '../store/store.dynamic-entry';
import { state as validationState } from '../store/store.validation';

export const validateVehicleConfigForm = (vehicleAnswers: AnswerVehicle, vehicleConfig: VehicleConfig, strobe: boolean = false) => {
  const errors = new Set<string>();
  const { isAssignedOffer } = dynamicEntryState;
  const { engineId, transmissionId, drivetrainId, colorId } = vehicleAnswers;
  const { excludedTransmissions, excludedEngines, excludedDrivetrains } = vehicleConfig;
  if (engineId === 0 || (excludedEngines.includes(engineId) && !isAssignedOffer)) {
    errors.add('engineId');
  }
  if (transmissionId === 0 || (excludedTransmissions.includes(transmissionId) && !isAssignedOffer)) {
    errors.add('transmissionId');
  }
  if (drivetrainId === 0 || (excludedDrivetrains.includes(drivetrainId) && !isAssignedOffer)) {
    errors.add('drivetrainId');
  }

  if (colorId === 0) {
    errors.add('colorId');
  }

  const isNewValid = !errors.size;
  const isOldValid = validationState.result.vehicleConfig;

  validationState.form = {
    ...validationState.form,
    vehicleConfig: errors,
  };

  validationState.result = {
    ...validationState.result,
    vehicleConfig: isNewValid,
  };

  if (strobe || isNewValid !== isOldValid) {
    EventBus.publish('FormValidated', { form: 'vehicle-config-form', isValid: isNewValid });
  }
};
